/**
 * Layout IDs
 */
export enum LayoutId {
  TWO_COLUMNS_LEFT = 1,
  SIX_COLUMNS = 2,
  TWO_ROWS = 3,
}

/**
 * Weekday numbers (Monday to Friday)
 * Using branded type for type safety
 */
export type WeekdayNumber = 2 | 3 | 4 | 5 | 6;
export const WEEKDAY_NUMBERS: readonly WeekdayNumber[] = [2, 3, 4, 5, 6] as const;

/**
 * Weekday Title Styles
 */
export enum WeekdayTitleStyle {
  PINNED = 1,
  NORMAL = 2,
}

/**
 * Weekday title positions
 */
export enum WeekdayTitlePosition {
  TOP = 'top',
  BOTTOM = 'bottom',
}

/**
 * Background theme category IDs
 * Maps to THEME_LIST in config.ts
 */
export enum BackgroundThemeId {
  GENERAL = 1,
  WOMENS_DAY = 2,
  LUNAR_NEW_YEAR = 3,
}

/**
 * Common width calculations for form fields
 */
export const FIELD_WIDTHS = {
  HALF: 'calc(50% - 8px)',
  FULL: '100%',
  QUARTER: 'calc(100%/4)',
} as const;
